import axios from "axios";

const baseDomain = process.env.CRM_API_URL || 'https://crm.spitzenleichtathletik.ch';
//const baseDomain = process.env.CRM_API_URL || 'http://localhost:8080';
const baseURL = `${baseDomain}/api/v1`; // Incase of /api/v1;
const token = localStorage.getItem('token');

// ALL DEFUALT CONFIGURATION HERE
export default axios.create({
    baseURL,
    headers: {
        "Content-type": "application/json;charset=utf-8",
         "Authorization": 'Bearer ' + token,
    }
});